import { useState } from 'react';
import { useNavigate } from 'react-router';

import { ILocumUserData } from '../../models/auth/signIn.model';
import { authActions } from '../../redux/slices/authSlice';
import { useAppDisPatch } from '../../redux/store';
import { ACCOUNT, SIGNIN, SIGNUP_OTP } from '../../routes/routeConstants';
import { useLocation } from 'react-router';
import { api } from '../../lib/api';

const useOnRefreshScreen = () => {
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState<string>();
  const navigate = useNavigate();
  const dispatch = useAppDisPatch();
  const location = useLocation();

  const raw = sessionStorage.getItem('invt');
  if (!raw) {
    const params = new URLSearchParams(location.search);
    if (params.get('invite') === 'true') {
      const jobId = params.get('jobId') || '';
      sessionStorage.setItem('invt', JSON.stringify({ state: true, jobId }));
    }
  }

  const onRefreshScreen = async () => {
    const data = localStorage.getItem('authData');

    if (!data) {
      setLoading(false);
      navigate(`/${ACCOUNT}/${SIGNIN}`, { replace: true });
      return null;
    }

    const authData: ILocumUserData = JSON.parse(data);

    try {
      // ✅ Verify token/session before bootstrapping app state
      await api.get(`auth-service/users/${authData?.id}`);
    } catch {
      // ❌ Session invalid: interceptor will alert+logout+redirect once.
      setLoading(false);
      return null;
    }

    if (!authData.isVerified) {
      setLoading(false);
      navigate(`/${ACCOUNT}/${SIGNUP_OTP}`, {
        replace: true,
        state: { data: authData.email },
      });
      return null;
    }

    // ✅ Good session: set app auth state
    dispatch(
      authActions.setAuthentication({ authData, isAuthenticated: true })
    );
    setUserId(authData.id);
    setLoading(false);
  };

  return {
    onRefreshScreen,
    loading,
    userId,
  };
};

export default useOnRefreshScreen;
